import { PermissionCodeEnum } from "@/types/enums/permissionEnum";
import { t } from '@/plugins/i18n'

export const DefaultRoles = [
    {
        role_name: t('role.admin'),
        value: 'admin'
    },
    {
        role_name: t('common.finance'),
        value: 'finance'
    },
    {
        role_name: t('role.operate'),
        value: 'operate'
    }
]

export const getPermissionDefaultMenus = () => {
    return [
        {
            label: t('home'),
            icon: 'kopic-shouye',
            code: PermissionCodeEnum.Dashboard,
            functions: [
                {
                    label: t('common.withdrawCash'),
                    code: PermissionCodeEnum.DashboardWithdrawCash,
                    checked: true
                }
            ],
            children: []
        },
        {
            label: t('order.center'),
            icon: 'kopic-dingdan',
            code: PermissionCodeEnum.Transaction,
            functions: [],
            children: [
                {
                    label: t('routes.business.orderDetail'),
                    code: PermissionCodeEnum.Bill,
                    functions: [
                        {
                            label: t('common.view'),
                            code: PermissionCodeEnum.BillView,
                            checked: true
                        },
                        {
                            label: t('sys.priceTemplate.detail'),
                            code: PermissionCodeEnum.BillDetail,
                            checked: true,
                        },
                        {
                            label: t('common.refunded'),
                            code: PermissionCodeEnum.BillRefund,
                            checked: true
                        },
                        {
                            label: t('common.export'),
                            code: PermissionCodeEnum.BillExport,
                            checked: true
                        }
                    ]
                },
                // {
                //     label: t('routes.business.merchantSettlement'),
                //     code: PermissionCodeEnum.Settlement,
                //     functions: [
                //         {
                //             label: t('common.view'),
                //             checked: true,
                //             code: PermissionCodeEnum.SettlementView
                //         },
                //         {
                //             label: t('common.export'),
                //             checked: true,
                //             code: PermissionCodeEnum.SettlementExport
                //         }
                //     ]
                // },
                {
                    label: t('order.reissue'),
                    code: PermissionCodeEnum.BillReissue,
                    functions: [
                        {
                            label: t('common.view'),
                            checked: true,
                            code: PermissionCodeEnum.BillReissueView
                        }
                    ]
                },
                {
                    label: t('routes.business.chargeback'),
                    code: PermissionCodeEnum.Chargeback,
                    functions: [
                        {
                            label: t('common.view'),
                            checked: true,
                            code: PermissionCodeEnum.ChargebackView
                        },
                        {
                            label: t('common.export'),
                            checked: true,
                            code: PermissionCodeEnum.ChargebackExport
                        }
                    ]
                },
                {
                    label: t('replace.payment'),
                    code: PermissionCodeEnum.ReplacePayment,
                    functions: [
                        {
                            label: t('common.view'),
                            checked: true,
                            code: PermissionCodeEnum.ReplacePaymentView
                        },
                        {
                            label: t('common.export'),
                            checked: true,
                            code: PermissionCodeEnum.ReplacePaymentExport
                        }
                    ]
                },
                {
                    label: t('chargeback.manage'),
                    code: PermissionCodeEnum.PaymentChargeback,
                    type: 'page',
                    functions: [
                        {
                            label: t('common.view'),
                            code: PermissionCodeEnum.PaymentChargebackView,
                            checked: true
                        }
                    ]
                }
            ]
        },
        // },
        {
            label: t('common.finance'),
            icon: 'kopic-zhifuzhongxin',
            code: PermissionCodeEnum.Finance,
            functions: [],
            children: [
                {
                    label: t('routes.business.tranDetail'),
                    code: PermissionCodeEnum.Business,
                    functions: [
                        {
                            label: t('common.view'),
                            checked: true,
                            code: PermissionCodeEnum.BusinessView
                        },
                        {
                            label: t('common.export'),
                            checked: true,
                            code: PermissionCodeEnum.BusinessExport
                        }
                    ]
                },
                {
                    label: t('recharge.history'),
                    code: PermissionCodeEnum.RechargeHistory,
                    functions: [
                        {
                            label: t('common.view'),
                            checked: true,
                            code: PermissionCodeEnum.RechargeHistoryView
                        }
                    ]
                },
                {
                    label: t('withdraw.cash'),
                    code: PermissionCodeEnum.WithdrawCash,
                    functions: [
                        {
                            label: t('common.view'),
                            checked: true,
                            code: PermissionCodeEnum.WithdrawCashView
                        },
                        {
                            label: t('common.export'),
                            checked: true,
                            code: PermissionCodeEnum.WithdrawCashExport
                        }
                    ]
                }
            ]
        },
        {
            label: t('sys.analyse.head'),
            icon: 'kopic-fenxi',
            code: PermissionCodeEnum.Analyze,
            functions: [],
            children: [
                {
                    label: t('common.water'),
                    code: PermissionCodeEnum.AnalyzeStream,
                    functions: [
                        {
                            label: t('common.view'),
                            code: PermissionCodeEnum.AnalyzeStreamView,
                            type: 'tab',
                            checked: true
                        }
                    ]
                },
                {
                    label: t('common.payer'),
                    code: PermissionCodeEnum.AnalyzePayUser,
                    functions: [
                        {
                            label: t('common.view'),
                            code: PermissionCodeEnum.AnalyzePayUserView,
                            type: 'tab',
                            checked: true
                        }
                    ]
                },
                {
                    label: t('conversion.rate'),
                    code: PermissionCodeEnum.AnalyzeRate,
                    functions: [
                        {
                            label: t('common.view'),
                            code: PermissionCodeEnum.AnalyzeRateView,
                            type: 'tab',
                            checked: true
                        }
                    ]
                },
                {
                    label: t('pay.rank'),
                    code: PermissionCodeEnum.AnalyzePaymentRank,
                    functions: [
                        {
                            label: t('common.view'),
                            code: PermissionCodeEnum.AnalyzePaymentRankView,
                            type: 'tab',
                            checked: true
                        }
                    ]
                },
                {
                    label: t('visitor.value'),
                    code: PermissionCodeEnum.AnalyzeVisits,
                    functions: [
                        {
                            label: t('common.view'),
                            code: PermissionCodeEnum.AnalyzeVisitsView,
                            type: 'tab',
                            checked: true
                        }
                    ]
                },
                {
                    label: t('pwa.analyze'),
                    code: PermissionCodeEnum.AnalyzePWA,
                    functions: [
                        {
                            label: t('common.view'),
                            code: PermissionCodeEnum.AnalyzePWAView,
                            checked: true
                        }
                    ]
                }
            ]
        },
        {
            label: t('vip.center'),
            icon: 'kopic-huiyuanguanli-copy',
            code: PermissionCodeEnum.VipCenter,
            functions: [],
            children: [
                {
                    label: t('vip.overview'),
                    code: PermissionCodeEnum.VipCenterOverview,
                    functions: [
                        {
                            label: t('common.view'),
                            code: PermissionCodeEnum.VipCenterOverviewView,
                            checked: true
                        }
                    ]
                },
                {
                    label: t('vip.rank'),
                    code: PermissionCodeEnum.VipCenterRank,
                    functions: [
                        {
                            label: t('common.view'),
                            code: PermissionCodeEnum.VipCenterRankView,
                            checked: true
                        },
                        {
                            label: t('common.editText'),
                            code: PermissionCodeEnum.VipCenterRankCreate,
                            checked: true
                        }
                    ]
                },
                {
                    label: t('points.system'),
                    code: PermissionCodeEnum.VipCenterPoints,
                    functions: [
                        {
                            label: t('common.view'),
                            code: PermissionCodeEnum.VipCenterPointsView,
                            type: 'button',
                            checked: true
                        }
                    ]
                },
            ]
        },
        {
            label: t('common.account'),
            icon: 'kopic-xitongquanxian',
            code: PermissionCodeEnum.Permission,
            functions: [],
            children: [
                {
                    label: t('user.permission'),
                    code: PermissionCodeEnum.PermissionUser,
                    links: [PermissionCodeEnum.PermissionUserDetail],
                    functions: [
                        {
                            label: t('common.view'),
                            code: PermissionCodeEnum.PermissionUserView,
                            checked: true,
                        },
                        {
                            label: t('common.editText'),
                            code: PermissionCodeEnum.PermissionUserViewEdit,
                            checked: true,
                        },
                        {
                            label: t('common.invite'),
                            code: PermissionCodeEnum.PermissionUserInvite,
                            checked: true,
                        }
                    ]
                },
                {
                    label: t('role.permission'),
                    code: PermissionCodeEnum.PermissionCreateRole,
                    links: [PermissionCodeEnum.PermissionRoleDetail],
                    functions: [
                        {
                            label: t('common.view'),
                            code: PermissionCodeEnum.PermissionCreateRoleView,
                            checked: true,
                        },
                        {
                            label: t('common.editText'),
                            code: PermissionCodeEnum.PermissionCreateRoleEdit,
                            checked: true,
                        },
                        {
                            label: t('common.creates'),
                            code: PermissionCodeEnum.PermissionCreateRoleNew,
                            checked: true,
                        }
                    ]
                },
                {
                    label: t('common.companySetting'),
                    code: PermissionCodeEnum.PermissionMerchantSetting,
                    functions: [
                        {
                            label: t('common.view'),
                            code: PermissionCodeEnum.PermissionMerchantSettingView,
                            checked: true,
                        },
                        {
                            label: t('common.editText'),
                            code: PermissionCodeEnum.PermissionMerchantSettingEdit,
                            checked: true,
                        }
                    ]
                },
                {
                    label: t('order.payment'),
                    code: PermissionCodeEnum.OrderPurchase,
                    functions: [
                        {
                            label: t('common.view'),
                            code: PermissionCodeEnum.OrderPurchaseView,
                            checked: true,
                        },
                        {
                            label: t('common.submit'),
                            code: PermissionCodeEnum.OrderPurchaseSubmit,
                            checked: true
                        }
                    ]
                },
                {
                    label: t('order.paymentHistory'),
                    code: PermissionCodeEnum.OrderPurchaseHistory,
                    functions: [
                        {
                            label: t('common.view'),
                            code: PermissionCodeEnum.OrderPurchaseHistoryView,
                            checked: true,
                        }
                    ]
                },
                {
                    label: t('order.paymentBill'),
                    code: PermissionCodeEnum.OrderPurchaseBill,
                    functions: [
                        {
                            label: t('common.view'),
                            code: PermissionCodeEnum.OrderPurchaseBillView,
                            checked: true,
                        }
                    ]
                }
            ]
        },
        {
            label: t('sys.project.all'),
            icon: 'kopic-suoyouyingyong',
            code: PermissionCodeEnum.App,
            functions: [
                {
                    label: t('common.creates'),
                    code: PermissionCodeEnum.AppCreate,
                    checked: true
                },
                {
                    label: t('common.delText'),
                    code: PermissionCodeEnum.AppDelete,
                    checked: true
                }
            ],
            children: []
        },
        {
            label: t('common.shop'),
            icon: 'kopic-shangpin',
            code: PermissionCodeEnum.Goods,
            functions: [],
            fromRouteCode: PermissionCodeEnum.App,
            children: [
                {
                    label: t('sys.store.good.category'),
                    code: PermissionCodeEnum.GoodsClassify,
                    type: 'page',
                    functions: [
                        {
                            label: t('common.view'),
                            code: PermissionCodeEnum.GoodsClassifyView,
                            checked: true
                        },
                        {
                            label: t('common.editText'),
                            code: PermissionCodeEnum.GoodsClassifyEdit,
                            checked: true
                        }
                    ]
                },
                {
                    label: t('goods.manage'),
                    code: PermissionCodeEnum.GoodsManage,
                    type: 'page',
                    functions: [
                        {
                            label: t('common.view'),
                            code: PermissionCodeEnum.GoodsManageView,
                            checked: true
                        },
                        {
                            label: t('common.editText'),
                            code: PermissionCodeEnum.GoodsManageEdit,
                            checked: true
                        }
                    ]
                },
                {
                    label: t('store.currency'),
                    code: PermissionCodeEnum.VirtualCurrency,
                    type: 'page',
                    functions: [
                        {
                            label: t('common.view'),
                            code: PermissionCodeEnum.VirtualCurrencyView,
                            checked: true
                        },
                        {
                            label: t('common.editText'),
                            code: PermissionCodeEnum.VirtualCurrencyEdit,
                            checked: true
                        }
                    ]
                },
                {
                    label: t('month.weekly.card'),
                    code: PermissionCodeEnum.MonthCard,
                    type: 'page',
                    functions: [
                        {
                            label: t('common.view'),
                            code: PermissionCodeEnum.MonthCardView,
                            checked: true
                        },
                        {
                            label: t('common.editText'),
                            code: PermissionCodeEnum.MonthCardEdit,
                            checked: true
                        }
                    ]
                },
                // {
                //     label: t('activity.replay'),
                //     code: PermissionCodeEnum.ActivityReplay,
                //     functions: [
                //         {
                //             label: t('common.view'),
                //             code: PermissionCodeEnum.ActivityReplayView,
                //             checked: true
                //         },
                //         {
                //             label: t('common.editText'),
                //             code: PermissionCodeEnum.ActivityReplayEdit,
                //             checked: true
                //         }
                //     ]
                // },
                {
                    label: t('common.recharge'),
                    code: PermissionCodeEnum.Recharge,
                    type: 'page',
                    functions: [
                        {
                            label: t('common.view'),
                            code: PermissionCodeEnum.RechargeView,
                            checked: true
                        },
                        {
                            label: t('common.editText'),
                            code: PermissionCodeEnum.RechargeEdit,
                            checked: true
                        }
                    ]
                },
                // {
                //     label: t('recharge.face'),
                //     code: PermissionCodeEnum.RechargeValue,
                //     type: 'page',
                //     functions: [
                //         {
                //             label: t('common.view'),
                //             code: PermissionCodeEnum.RechargeValueView,
                //             checked: true
                //         },
                //         {
                //             label: t('common.editText'),
                //             code: PermissionCodeEnum.RechargeValueEdit,
                //             checked: true
                //         }
                //     ]
                // },
                {
                    label: t('props.library'),
                    code: PermissionCodeEnum.PropsLibrary,
                    type: 'page',
                    functions: [
                        {
                            label: t('common.view'),
                            code: PermissionCodeEnum.PropsLibraryView,
                            checked: true
                        },
                        {
                            label: t('common.new'),
                            code: PermissionCodeEnum.PropsLibraryCreate,
                            checked: true
                        },
                        {
                            label: t('common.editText'),
                            code: PermissionCodeEnum.PropsLibraryEdit,
                            checked: true
                        },
                        {
                            label: t('common.delText'),
                            code: PermissionCodeEnum.PropsLibraryDelete,
                            checked: true
                        }
                    ]
                }
            ]
        },
        {
            label: t('sys.store.activity.menuName'),
            icon: 'kopic-yingxiao',
            code: PermissionCodeEnum.Activity,
            functions: [],
            children: [
                {
                    label: t('common.xy'),
                    code: PermissionCodeEnum.ActivityXy,
                    functions: [
                        {
                            label: t('common.view'),
                            code: PermissionCodeEnum.ActivityXyView,
                            checked: true
                        },
                        {
                            label: t('common.creates'),
                            code: PermissionCodeEnum.ActivityXyCreate,
                            checked: true
                        },
                        {
                            label: t('common.editText'),
                            code: PermissionCodeEnum.ActivityXyEdit,
                            links: [PermissionCodeEnum.ActivityXyCreate],
                            checked: true
                        },
                        {
                            label: t('common.delText'),
                            code: PermissionCodeEnum.ActivityXyDelete,
                            checked: true
                        }
                    ]
                },
                {
                    label: t('exhausted.charge'),
                    code: PermissionCodeEnum.ActivityAddUp,
                    functions: [
                        {
                            label: t('common.view'),
                            code: PermissionCodeEnum.ActivityAddUpView,
                            checked: true
                        },
                        {
                            label: t('common.creates'),
                            code: PermissionCodeEnum.ActivityAddUpCreate,
                            checked: true
                        },
                        {
                            label: t('common.editText'),
                            code: PermissionCodeEnum.ActivityAddUpEdit,
                            links: [PermissionCodeEnum.ActivityAddUpCreate],
                            checked: true
                        },
                        {
                            label: t('common.replay'),
                            code: PermissionCodeEnum.ActivityAddUpReplay,
                            checked: true
                        },
                        {
                            label: t('common.delText'),
                            code: PermissionCodeEnum.ActivityAddUpDelete,
                            checked: true
                        }
                    ]
                },
                {
                    label: t('user.first'),
                    code: PermissionCodeEnum.ActivityUserFirstRecharge,
                    functions: [
                        {
                            label: t('common.view'),
                            code: PermissionCodeEnum.ActivityUserFirstRechargeView,
                            checked: true
                        },
                        {
                            label: t('common.creates'),
                            code: PermissionCodeEnum.ActivityUserFirstRechargeCreate,
                            checked: true
                        },
                        {
                            label: t('common.editText'),
                            code: PermissionCodeEnum.ActivityUserFirstRechargeEdit,
                            links: [PermissionCodeEnum.ActivityFirstBuyCreate],
                            checked: true
                        },
                        {
                            label: t('common.replay'),
                            code: PermissionCodeEnum.ActivityUserFirstRechargeReplay,
                            checked: true
                        },
                        {
                            label: t('common.delText'),
                            code: PermissionCodeEnum.ActivityUserFirstRechargeDelete,
                            checked: true
                        }
                    ]
                },
                {
                    label: t('common.activityFirst'),
                    code: PermissionCodeEnum.ActivityFirstBuy,
                    functions: [
                        {
                            label: t('common.view'),
                            code: PermissionCodeEnum.ActivityFirstBuyView,
                            checked: true
                        },
                        {
                            label: t('common.creates'),
                            code: PermissionCodeEnum.ActivityFirstBuyCreate,
                            checked: true
                        },
                        {
                            label: t('common.editText'),
                            code: PermissionCodeEnum.ActivityFirstBuyEdit,
                            links: [PermissionCodeEnum.ActivityFirstBuyCreate],
                            checked: true
                        },
                        {
                            label: t('common.delText'),
                            code: PermissionCodeEnum.ActivityFirstBuyDelete,
                            checked: true
                        }
                    ]
                },
                {
                    label: t('goods.limit'),
                    code: PermissionCodeEnum.ActivityLimit,
                    functions: [
                        {
                            label: t('common.view'),
                            code: PermissionCodeEnum.ActivityLimitView,
                            checked: true
                        },
                        {
                            label: t('common.creates'),
                            code: PermissionCodeEnum.ActivityLimitCreate,
                            checked: true
                        },
                        {
                            label: t('common.editText'),
                            code: PermissionCodeEnum.ActivityLimitEdit,
                            links: [PermissionCodeEnum.ActivityLimitCreate],
                            checked: true
                        },
                        {
                            label: t('common.delText'),
                            code: PermissionCodeEnum.ActivityLimitDelete,
                            checked: true
                        }
                    ]
                },
                // {
                //     label: t('recharge.discount'),
                //     code: PermissionCodeEnum.ActivityRecharge,
                //     functions: [
                //         {
                //             label: t('common.view'),
                //             code: PermissionCodeEnum.ActivityRechargeView,
                //             checked: true
                //         },
                //         {
                //             label: t('common.creates'),
                //             code: PermissionCodeEnum.ActivityRechargeCreate,
                //             checked: true
                //         },
                //         {
                //             label: t('common.editText'),
                //             code: PermissionCodeEnum.ActivityRechargeEdit,
                //             links: [PermissionCodeEnum.ActivityRechargeCreate],
                //             checked: true
                //         }
                //     ]
                // },   
                {
                    label: t('common.sign'),
                    code: PermissionCodeEnum.ActivitySignIn,
                    functions: [
                        {
                            label: t('common.view'),
                            code: PermissionCodeEnum.ActivitySignInView,
                            checked: true
                        },
                        {
                            label: t('common.creates'),
                            code: PermissionCodeEnum.ActivitySignInCreate,
                            checked: true
                        },
                        {
                            label: t('common.editText'),
                            code: PermissionCodeEnum.ActivitySignInEdit,
                            links: [PermissionCodeEnum.ActivitySignInCreate],
                            checked: true
                        },
                        {
                            label: t('common.replay'),
                            code: PermissionCodeEnum.ActivitySignInReplay,
                            checked: true
                        },
                        {
                            label: t('common.delText'),
                            code: PermissionCodeEnum.ActivitySignInDelete,
                            checked: true
                        }
                    ]
                },
                {
                    label: t('common.conRecharge'),
                    code: PermissionCodeEnum.ActivityConsecutive,
                    functions: [
                        {
                            label: t('common.view'),
                            code: PermissionCodeEnum.ActivityConsecutiveView,
                            checked: true
                        },
                        {
                            label: t('common.creates'),
                            code: PermissionCodeEnum.ActivityConsecutiveCreate,
                            checked: true
                        },
                        {
                            label: t('common.editText'),
                            code: PermissionCodeEnum.ActivityConsecutiveEdit,
                            links: [PermissionCodeEnum.ActivityConsecutiveCreate],
                            checked: true
                        },
                        {
                            label: t('common.replay'),
                            code: PermissionCodeEnum.ActivityConsecutiveReplay,
                            checked: true
                        },
                        {
                            label: t('common.delText'),
                            code: PermissionCodeEnum.ActivityConsecutiveDelete,
                            checked: true
                        }
                    ]
                },
                {
                    label: t('common.lottery'),
                    code: PermissionCodeEnum.ActivityLottery,
                    functions: [
                        {
                            label: t('common.view'),
                            code: PermissionCodeEnum.ActivityLotteryView,
                            checked: true
                        },
                        {
                            label: t('common.creates'),
                            code: PermissionCodeEnum.ActivityLotteryCreate,
                            checked: true
                        },
                        {
                            label: t('common.editText'),
                            code: PermissionCodeEnum.ActivityLotteryEdit,
                            links: [PermissionCodeEnum.ActivityLotteryCreate],
                            checked: true
                        },
                        {
                            label: t('common.replay'),
                            code: PermissionCodeEnum.ActivityLotteryReplay,
                            checked: true
                        },
                        {
                            label: t('common.delText'),
                            code: PermissionCodeEnum.ActivityLotteryDelete,
                            checked: true
                        }
                    ]
                },
                {
                    label: t('convert.key'),
                    code: PermissionCodeEnum.ConvertKey,
                    type: 'page',
                    functions: [
                        {
                            label: t('common.view'),
                            code: PermissionCodeEnum.ConvertKeyView,
                            checked: true
                        },
                        {
                            label: t('common.creates'),
                            code: PermissionCodeEnum.CoverKeyCreate,
                            checked: true
                        },
                        {
                            label: t('common.delText'),
                            code: PermissionCodeEnum.CoverKeyDelete,
                            checked: true
                        }
                    ]
                },
                {
                    label: t('full.discount'),
                    code: PermissionCodeEnum.ActivityFullDiscount,
                    type: 'page',
                    functions: [
                        {
                            label: t('common.view'),
                            code: PermissionCodeEnum.ActivityFullDiscountView,
                            checked: true
                        },
                        {
                            label: t('common.creates'),
                            code: PermissionCodeEnum.ActivityFullDiscountCreate,
                            checked: true
                        },
                        {
                            label: t('common.editText'),
                            code: PermissionCodeEnum.ActivityFullDiscountEdit,
                            links: [PermissionCodeEnum.ActivityFullDiscountCreate],
                            checked: true
                        },
                        {
                            label: t('common.replay'),
                            code: PermissionCodeEnum.ActivityFullDiscountReplay,
                            checked: true
                        },
                        {
                            label: t('common.delText'),
                            code: PermissionCodeEnum.ActivityFullDiscountDelete,
                            checked: true
                        }
                    ]
                },
                {
                    label: t('invite.code'),
                    code: PermissionCodeEnum.ActivityInviteCode,
                    type: 'page',
                    functions: [
                        {
                            label: t('common.view'),
                            code: PermissionCodeEnum.ActivityInviteCodeView,
                            checked: true
                        },
                        {
                            label: t('common.editText'),
                            code: PermissionCodeEnum.ActivityInviteCodeEdit,
                            checked: true
                        },
                        {
                            label: t('common.delText'),
                            code: PermissionCodeEnum.ActivityInviteCodeDelete,
                            checked: true
                        }
                    ]
                },
                {
                    label: t('quen.unlock'),
                    code: PermissionCodeEnum.ActivityQuenUnlock,
                    type: 'page',
                    functions: [
                        {
                            label: t('common.view'),
                            code: PermissionCodeEnum.ActivityQuenUnlockView,
                            checked: true
                        },
                        {
                            label: t('common.creates'),
                            code: PermissionCodeEnum.ActivityQuenUnlockCreate,
                            checked: true
                        },
                        {
                            label: t('common.editText'),
                            code: PermissionCodeEnum.ActivityQuenUnlockEdit,
                            links: [PermissionCodeEnum.ActivityQuenUnlockCreate],
                            checked: true
                        },
                        {
                            label: t('common.replay'),
                            code: PermissionCodeEnum.ActivityQuenUnlockReplay,
                            checked: true
                        },
                        {
                            label: t('common.delText'),
                            code: PermissionCodeEnum.ActivityQuenUnlockDelete,
                            checked: true
                        }
                    ]
                }
                // {
                //     label: '优惠券',
                //     code: PermissionCodeEnum.ActivityCoupon,
                //     type: 'page',
                //     functions: [
                //         {
                //             label: t('common.view'),
                //             code: PermissionCodeEnum.ActivityCouponView,
                //             checked: true
                //         },
                //         {
                //             label: t('common.replay'),
                //             code: PermissionCodeEnum.ActivityCouponReplay,
                //             checked: true
                //         },
                //         {
                //             label: t('common.editText'),
                //             code: PermissionCodeEnum.ActivityCouponEdit,
                //             checked: true
                //         }
                //     ]
                // }
            ]
        },
        {
            label: t('mission.center'),
            code: PermissionCodeEnum.MissionCenter,
            icon: 'kopic-ef-renwu-gongju',
            children: [],
            links: [PermissionCodeEnum.MissionCenterCreate],
            functions: [
                {
                    label: t('common.view'),
                    code: PermissionCodeEnum.MissionCenterView,
                    checked: true
                },
                {
                    label: t('common.editText'),
                    code: PermissionCodeEnum.MissionCenterEdit,
                    links: [PermissionCodeEnum.MissionCenterCreate],
                    checked: true
                },
                // {
                //     label: t('common.replay'),
                //     code: PermissionCodeEnum.MissionCenterReplay,
                //     checked: true
                // },
                // {
                //     label: t('common.switch'),
                //     code: PermissionCodeEnum.MissionCenterSwitch,
                //     checked: true
                // }
            ]
        },
        {
            label: t('pay.center'),
            icon: 'kopic-zhifuzhongxin',
            code: PermissionCodeEnum.Payment,
            fromRouteCode: PermissionCodeEnum.App,
            functions: [],
            children: [
                {
                    label: t('pay.methods'),
                    code: PermissionCodeEnum.PaymentType,
                    type: 'page',
                    functions: [
                        {
                            label: t('common.view'),
                            code: PermissionCodeEnum.PaymentTypeView,
                            checked: true
                        },
                        {
                            label: t('common.editText'),
                            code: PermissionCodeEnum.PaymentTypeEdit,
                            checked: true
                        }
                    ]
                },
                {
                    label: t('pay.sort'),
                    code: PermissionCodeEnum.PaymentSort,
                    type: 'page',
                    functions: [
                        {
                            label: t('common.view'),
                            code: PermissionCodeEnum.PaymentSortView,
                            checked: true
                        },
                        {
                            label: t('common.editText'),
                            code: PermissionCodeEnum.PaymentSortEdit,
                            checked: true
                        }
                    ]
                },
                {
                    label: t('pay.config'),
                    code: PermissionCodeEnum.PaymentConfig,
                    type: 'page',
                    functions: [
                        {
                            label: t('common.view'),
                            code: PermissionCodeEnum.PaymentConfigView,
                            checked: true
                        },
                        {
                            label: t('sys.store.config'),
                            code: PermissionCodeEnum.PaymentConfigEdit,
                            checked: true
                        }
                    ]
                }
            ]
        },
        {
            label: t('sys.store.siteDesign'),
            icon: 'kopic-zaixianshangcheng',
            code: PermissionCodeEnum.Store,
            fromRouteCode: PermissionCodeEnum.App,
            children: [
                {
                    label: t('store.config'),
                    code: PermissionCodeEnum.StoreDomain,
                    type: 'page',
                    functions: [
                        {
                            label: t('change.domain'),
                            code: PermissionCodeEnum.StoreDomainChange,
                            checked: true
                        },
                        {
                            label: t('sys.project.domain.addDomain'),
                            code: PermissionCodeEnum.StoreDomainAdd,
                            checked: true
                        },
                        {
                            label: t('remove.domain'),
                            code: PermissionCodeEnum.StoreDomainDelete,
                            checked: true
                        },
                        {
                            label: t('change.visitor.whiteCountry'),
                            code: PermissionCodeEnum.StoreVisitorCountryChange,
                            checked: true
                        },
                        {
                            label: t('change.register.pay'),
                            code: PermissionCodeEnum.StoreRegisterLocalPayChange,
                            checked: true
                        }
                    ]
                },
                {
                    label: t('page.config'),
                    code: PermissionCodeEnum.StorePage,
                    type: 'page',
                    functions: [
                        {
                            label: t('sys.project.addPage'),
                            code: PermissionCodeEnum.StorePageAdd,
                            checked: true
                        },
                        {
                            label: t('edit.page'),
                            code: PermissionCodeEnum.StorePageEdit,
                            checked: true
                        },
                        {
                            label: t('delete.page'),
                            code: PermissionCodeEnum.StorePageDelete,
                            checked: true
                        }
                    ]
                },
                {
                    label: t('user.manage'),
                    code: PermissionCodeEnum.StoreUser,
                    type: 'page',
                    functions: [
                        {
                            label: t('common.saveText'),
                            code: PermissionCodeEnum.StoreUserSave,
                            checked: true
                        }
                    ]
                },
                {
                    label: t('viewSource.manage'),
                    code: PermissionCodeEnum.StoreFlowOrigin,
                    type: 'page',
                    functions: [
                        {
                            label: t('add.flow'),
                            code: PermissionCodeEnum.StoreFlowOriginAdd,
                            checked: true
                        },
                        {
                            label: t('edit.source'),
                            code: PermissionCodeEnum.StoreFlowOriginEdit,
                            checked: true
                        },
                        {
                            label: t('delete.source'),
                            code: PermissionCodeEnum.StoreFlowOriginDelete,
                            checked: true
                        }
                    ]
                }
            ],
            functions: [
                {
                    label: t('common.view'),
                    code: PermissionCodeEnum.StoreView,
                    checked: true
                },
                {
                    label: t('common.editText'),
                    code: PermissionCodeEnum.StoreEdit,
                    checked: true
                },
                {
                    label: t('common.deploy'),
                    code: PermissionCodeEnum.StorePublish,
                    checked: true
                }
            ]
        },
        {
            label: t('vip.center'),
            code: PermissionCodeEnum.ProjectMemberCenter,
            icon: 'kopic-huiyuanzhongxin',
            functions: [],
            children: [
                {
                    label: t('vip.overview'),
                    code: PermissionCodeEnum.ProjectMemberOverview,
                    functions: [
                        {
                            label: t('common.view'),
                            code: PermissionCodeEnum.ProjectMemberOverviewView,
                            checked: true
                        },
                        {
                            label: t('common.editText'),
                            code: PermissionCodeEnum.ProjectMemberOverviewEdit,
                            checked: true
                        }
                    ]
                },
                {
                    label: t('rank.label'),
                    code: PermissionCodeEnum.ProjectMemberRank,
                    functions: [
                        {
                            label: t('common.view'),
                            code: PermissionCodeEnum.ProjectMemberRankView,
                            checked: true
                        },
                        {
                            label: t('rights.create'),
                            code: PermissionCodeEnum.ProjectMemberRightsCreate,
                            checked: true
                        },
                        {
                            label: t('rights.edit'),
                            code: PermissionCodeEnum.ProjectMemberRightsEdit,
                            checked: true
                        },
                        {
                            label: t('rights.delete'),
                            code: PermissionCodeEnum.ProjectMemberRightsDelete,
                            checked: true
                        },
                        {
                            label: t('create.level'),
                            code: PermissionCodeEnum.ProjectMemberRankCreate,
                            checked: true
                        },
                        {
                            label: t('edit.level'),
                            code: PermissionCodeEnum.ProjectMemberRankEdit,
                            links: [PermissionCodeEnum.ProjectMemberRankCreate],
                            checked: true
                        },
                        {
                            label: t('rank.delete'),
                            code: PermissionCodeEnum.ProjectMemberRankDelete,
                            checked: true
                        }
                    ]
                }
            ]
        },
        {
            label: t('sys.store.userGroup'),
            code: PermissionCodeEnum.UserGroup,
            icon: 'kopic-yonghuqunti',
            fromRouteCode: PermissionCodeEnum.App,
            children: [],
            functions: [
                {
                    label: t('common.view'),
                    code: PermissionCodeEnum.UserGroupView,
                    type: 'button',
                    checked: true
                },
                {
                    label: t('common.creates'),
                    code: PermissionCodeEnum.UserGroupCreate,
                    type: 'button',
                    checked: true
                }
            ]
        },
        {
            label: t('sys.store.setting'),
            icon: 'kopic-yingyongshezhi',
            code: PermissionCodeEnum.App,
            functions: [],
            children: [
                {
                    label: t('sys.project.setting.generalSetting'),
                    code: PermissionCodeEnum.AppDetail,
                    functions: [
                        // {
                        //     label: t('common.view'),
                        //     code: PermissionCodeEnum.AppDetailView,
                        //     checked: true,
                        // },
                        {
                            label: t('common.editText'),
                            code: PermissionCodeEnum.AppDetailEdit,
                            checked: true,
                        }
                    ]
                },
                {
                    label: 'webhooks',
                    code: PermissionCodeEnum.AppWebhook,
                    functions: [
                        {
                            label: t('common.view'),
                            code: PermissionCodeEnum.AppWebhookView,
                            checked: true,
                        },
                        {
                            label: t('common.editText'),
                            code: PermissionCodeEnum.AppWebhookEdit,
                            checked: true,
                        }
                    ]
                },
                {
                    label: t('sys.project.priceTamplate'),
                    code: PermissionCodeEnum.PriceTemplate,
                    functions: [
                        {
                            label: t('common.view'),
                            code: PermissionCodeEnum.PriceTemplateView,
                            checked: true,
                        },
                        {
                            label: t('common.editText'),
                            code: PermissionCodeEnum.PriceTemplateEdit,
                            checked: true,
                        }
                    ]
                },
                {
                    label: t('auto.update.price'),
                    code: PermissionCodeEnum.AutoUpdatePrice,
                    functions: [
                        {
                            label: t('common.view'),
                            code: PermissionCodeEnum.AutoUpdatePriceView,
                            checked: true,
                        },
                        {
                            label: t('common.editText'),
                            code: PermissionCodeEnum.AutoUpdatePriceEdit,
                            checked: true,
                        }
                    ]
                },
                {
                    label: t('risk.manage'),
                    code: PermissionCodeEnum.RiskManage,
                    functions: [
                        {
                            label: t('common.view'),
                            code: PermissionCodeEnum.RiskManageView,
                            checked: true,
                        },
                        {
                            label: t('common.editText'),
                            code: PermissionCodeEnum.RiskManageEdit,
                            checked: true,
                        }
                    ]
                },
                {
                    label: t('language.library'),
                    code: PermissionCodeEnum.LanguageManage,
                    functions: [
                        {
                            label: t('common.view'),
                            code: PermissionCodeEnum.LanguageManageView,
                            checked: true,
                        },
                        {
                            label: t('common.editText'),
                            code: PermissionCodeEnum.LanguageManageEdit,
                            checked: true,
                        }
                    ]
                }
            ]
        },
        {
            label: t('service.market'),
            code: PermissionCodeEnum.Market,
            icon: 'kopic-shichangtuozhan',
            children: [],
            functions: [
                {
                    label: t('common.view'),
                    code: PermissionCodeEnum.MarketView,
                    checked: true
                },
                {
                    label: t('common.editText'),
                    code: PermissionCodeEnum.MarketEdit,
                    checked: true
                }
            ]
        }
    ]
}
